import { useCallback, useState } from 'react';

const STORAGE_KEY = 'inspirationScreenEnabled';

const readPreference = (): boolean => {
  try {
    return localStorage.getItem(STORAGE_KEY) === 'true';
  } catch {
    return false;
  }
};

/** Whether the fullscreen inspiration view opens automatically after inactivity. Off by default. */
export const useInspirationScreenPreference = () => {
  const [enabled, setEnabledState] = useState<boolean>(readPreference);

  const setEnabled = useCallback((value: boolean) => {
    setEnabledState(value);
    try {
      localStorage.setItem(STORAGE_KEY, String(value));
    } catch {
      // Storage unavailable (private mode); keep the in-memory value.
    }
  }, []);

  return { enabled, setEnabled };
};
